import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Register() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ name: '', username: '', password: '' });

    const handleRegister = async (e) => {
    e.preventDefault(); // Evita que a página recarregue
    
    if (!formData.name || !formData.username || !formData.password) {
        alert("Por favor, preencha todos os campos.");
        return;
    }

    try {
        const response = await fetch('https://hubdaive.com.br/api/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: formData.name,
                username: formData.username,
                password: formData.password
            }),
        });

        const data = await response.json();

        if (response.ok) {
            alert("Conta criada com sucesso! Redirecionando para o login...");
            navigate('/');
        } else {
            alert(data.detail || "Erro ao criar conta.");
        }
    } catch (error) {
        console.error("Erro na requisição de registro:", error);
        alert("Erro ao conectar com o servidor.");
    }
};

    const containerStyle = { 
        height: '100vh', width: '100vw', backgroundColor: '#000', fontSize:'2vh', 
        display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' 
    };

    return (
        <div style={containerStyle}>
            <div style={{ width: '30vw', height:'50vh', textAlign: 'center' }}>
                <h2 style={{ marginBottom: '5vh' }}>Criar nova conta</h2>
                
                <input 
                    placeholder="Nome Completo" 
                    style={inputStyle} 
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                />
                <input 
                    placeholder="E-mail Daive" 
                    style={inputStyle} 
                    onChange={(e) => setFormData({...formData, username: e.target.value})}
                />
                <input 
                    type="password" 
                    placeholder="Senha" 
                    style={inputStyle} 
                    onChange={(e) => setFormData({...formData, password: e.target.value})}
                />

                <button 
                    onClick={handleRegister}
                    style={buttonStyle}>Cadastrar
                    </button>
                
                <p 
                    onClick={() => navigate('/')} 
                    style={{ marginTop: '2vh', fontSize: '2.0vh', marginLeft:'1vw', cursor: 'pointer', color: '#888' }}
                >
                    Já tem uma conta? Voltar ao Login
                </p>
            </div>
        </div>
    );
}

const inputStyle = { width: '100%', padding: '1.5vh', fontSize: '1.5vh', marginBottom: '3vh', backgroundColor: '#111', border: '1px solid #333', color: '#fff', borderRadius: '8px' };
const buttonStyle = { width: '100%', padding: '1.5vh', marginTop:'5vh', marginLeft:'1vw', backgroundColor: '#007AFF', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' };

export default Register;